import { render } from "./UserModal.vue?vue&type=template&id=04fa758d&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=04fa758d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fa758d"]])

export default __exports__